import { Button, DataGrid, Form, ScrollView } from "devextreme-react";
import { GroupItem } from "devextreme-react/form";
import { useHistory, useParams } from "react-router";
import { Tabs } from "../../../components";
import { useEffect, useRef, useState } from "react";
import { ApiResponse, verfiyResponse } from "../../../types/models/base-model";
import { useDispatch, useSelector } from "react-redux";
import { getApiParams } from "../../../redux/auth";
import { BodyType, createRequest } from "../../../redux/base/request";
import notify from "devextreme/ui/notify";
import loader from "../../../redux/loader";
import { getLocalized } from "../../../redux/localization";
import { Product, ProductStatusDto } from "../types";
import ProductDetailForm from "./tabs/detail";

const ProductDetailPage = () => {
  const localize = useSelector(getLocalized);
  const history = useHistory();
  const [loading, setLoader] = useState(false);
  const [status, setStatus] = useState<ProductStatusDto[]>();
  const dispatch = useDispatch();
  const { token, lang } = useSelector(getApiParams);
  const { Id }: { Id: string } = useParams();
  const dataRef = useRef<Product>();

  const request = async () => {
    const response: ApiResponse<Product> = await createRequest({
      method: "GET",
      url: "api/admin/products/" + Id,
      bodyType: BodyType.formdata,
      token,
      lang,
    });
    if (verfiyResponse(response)) {
      dataRef.current = response.Result;
    } else notify(response.Message, "error");
    const status: ApiResponse<ProductStatusDto[]> = await createRequest({
      method: "GET",
      url: "api/admin/products/product-statuses",
      token,
      lang,
    });
    if (verfiyResponse(status)) {
      setStatus(status.Result);
      setLoader(true);
    } else notify(response.Message, "error");
  };

  useEffect(() => {
    dispatch(loader.actions.showLoader());
    request();
    dispatch(loader.actions.hideLoader());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <form>
      <Form
        key="Id"
        visible={loading}
        labelLocation="top"
        formData={dataRef.current}
        showColonAfterLabel={true}
      >
        <GroupItem>
          <div className={"tab-pabel-product"}>
            <Tabs
              key="Id"
              children={[
                {
                  title: localize.getString("productdetails"),
                  component: (
                    <>
                      <ProductDetailForm
                        data={dataRef.current}
                        status={status}
                      />
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-end",
                          marginBlockStart: 5,
                        }}
                      >
                        <Button
                          width={120}
                          text={"Close"}
                          type="default"
                          stylingMode="contained"
                          onClick={() => history.goBack()}
                        />
                      </div>
                    </>
                  ),
                },
                {
                  title: "Ürün Fiyatları",
                  component: (
                    <ScrollView>
                      <DataGrid
                        key={"Id"}
                        dataSource={dataRef.current?.ProductRates}
                        showBorders
                        showRowLines
                        columnAutoWidth
                        columnHidingEnabled
                        rowAlternationEnabled
                        allowColumnResizing
                        allowColumnReordering
                        columns={[
                          {
                            dataField: "StartDate",
                            caption: localize.getString("startDate"),
                            dataType: "date",
                          },
                          {
                            dataField: "EndDate",
                            caption: localize.getString("endDate"),
                            dataType: "date",
                          },
                          {
                            dataField: "Amount",
                            caption: localize.getString("amount"),
                          },
                          {
                            dataField: "MininumRent",
                            caption: localize.getString("minimumRentDay"),
                          },
                          {
                            dataField: "MaximumRent",
                            caption: localize.getString("maximumRentDay"),
                          },
                        ]}
                      ></DataGrid>
                    </ScrollView>
                  ),
                },
              ]}
            />
          </div>
        </GroupItem>
      </Form>
    </form>
  );
};
export default ProductDetailPage;
